import {get, post, put} from "../../core/api";
import {Meeting, MeetingParticipant} from "./Meeting";

export const getMeetingsHistory = (profileId: string): Promise<Meeting[]> => {
    return get(`/client-management/profiles/${profileId}/meetings`)
        .then(extractBody)
}


export const getMeeting = (profileId: string, meetingId: string): Promise<Meeting> => {
    return get(`/client-management/profiles/${profileId}/meeting/${meetingId}`)
        .then(extractBody)
}

export const createMeeting = (meeting: Meeting): Promise<Meeting> => {

    return post(`/client-management/profiles/${meeting.profileId}/meetings`, meeting)
        .then(extractBody)
};

export const updateMeeting = (meeting: Meeting): Promise<Meeting> => {
    const modifiedMeetingRequest = {...meeting}

    return put(`/client-management/profiles/${meeting.profileId}/meeting/${meeting.id}`, modifiedMeetingRequest)
        .then(extractBody)
};

export const addParticipant = (profileId: string, meetingParticipant: MeetingParticipant): Promise<MeetingParticipant> => {
    return post(`/client-management/profiles/${profileId}/meetingParticipant`, meetingParticipant).then(extractBody);
};

export const getMeetingParticipants = (profileId: string, onlineMeetingId: string): Promise<MeetingParticipant[]> => {
    return get(`/client-management/profiles/${profileId}/meetingParticipants`, {
        queryParams: {
            onlineMeetingId
        }
    }).then(extractBody)
}

export const meetingApiClient = {
    getMeetingsHistory: getMeetingsHistory,
    getMeeting: getMeeting,
    createMeeting: createMeeting,
    updateMeeting: updateMeeting,
    addParticipant: addParticipant,
    getMeetingParticipants: getMeetingParticipants,
}

const extractBody = (res: Response) => res.json();